<template>
  <div class="page-container md-layout-column">
    <menu-bar></menu-bar>
    <md-content class="TL_BookSession">
        <router-view
            class="Page">
        </router-view>
    </md-content>
    <toast></toast>
  </div>
</template>

<script>
  import "./sass/main.scss";
  import Toast from "./components/toast/toast.vue";

  export default {
    name: 'App',
    components: { Toast },
    methods: {},
    data: () => ({}),
  };
</script>
